(function(){
  'use strict';
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var WA='https://wa.me/919667978844';
  /* The theme scrolls .page-wrapper, not the window. Relay its scroll to
     window so every scroll listener on the site works, and read y from it. */
  var PW=null;
  function sc(){if(PW===null){var p=document.querySelector('.page-wrapper');PW=(p&&p.scrollHeight>p.clientHeight+40&&/(auto|scroll)/.test(getComputedStyle(p).overflowY))?p:false}return PW}
  function sy(){var p=sc();return p?p.scrollTop:(window.scrollY||document.documentElement.scrollTop)}
  function sh(){var p=sc();return p?p.scrollHeight-p.clientHeight:document.documentElement.scrollHeight-window.innerHeight}
  document.addEventListener('scroll',function(e){if(e.target&&e.target.classList&&e.target.classList.contains('page-wrapper'))window.dispatchEvent(new Event('scroll'))},{passive:true,capture:true});
  function ready(fn){document.readyState!=='loading'?fn():document.addEventListener('DOMContentLoaded',fn)}
  function rgba(s){var m=(s||'').match(/[\d.]+/g);if(!m)return [0,0,0,0];return [+m[0],+m[1],+m[2],m[3]===undefined?1:+m[3]]}
  function lum(c){return [c[0],c[1],c[2]].map(function(v){v/=255;return v<=.03928?v/12.92:Math.pow((v+.055)/1.055,2.4)}).reduce(function(a,v,i){return a+v*[.2126,.7152,.0722][i]},0)}
  function behind(el){el=el.parentElement;while(el){var b=rgba(getComputedStyle(el).backgroundColor);if(b[3]>.5)return b;el=el.parentElement}return [243,238,223,1]}

  /* 1. No white CTA. Any button-shaped link that computes to a white or cream
     fill, or to white text on a white fill, is recoloured: forest on light
     grounds, brass on dark ones. */
  function ctaSweep(){
    var els=document.querySelectorAll('a.s-pill,a.btn,button.btn,a[class*="button"],button[class*="button"],.lp a.btn,a[class*="cta"]');
    Array.prototype.forEach.call(els,function(el){
      if(el.closest('.sv-wa')||el.offsetWidth<40)return;
      var cs=getComputedStyle(el),bg=rgba(cs.backgroundColor);
      if(bg[3]<.5||lum(bg)<.72)return;
      var under=behind(el);
      var dark=lum(under)<.25;
      el.classList.add(dark?'sv-cta-fix--ondark':'sv-cta-fix');
      /* If an older rule still wins, force it inline. */
      if(lum(rgba(getComputedStyle(el).backgroundColor))>.72){
        el.style.setProperty('background-color',dark?'#D8A84E':'#174C3A','important');
        el.style.setProperty('border-color',dark?'#D8A84E':'#174C3A','important');
        el.style.setProperty('color',dark?'#171717':'#FAF7EF','important');
      }
    });
    /* Primaries get the sheen. */
    Array.prototype.forEach.call(document.querySelectorAll('.sh-close .s-pill:not(.sh-close__wa),.sc26__button:first-of-type,.sjb__button:first-of-type,.pd-sticky__book,.lp .btn.b1,.sv-cta-fix,.sv-cta-fix--ondark'),function(el){el.classList.add('sv-sheen')});
  }

  /* 2. Images fade in once decoded. Only below-the-fold, lazy images, so the
     first paint is never held back. */
  function images(){
    if(reduce)return;
    var vh=window.innerHeight;
    Array.prototype.forEach.call(document.querySelectorAll('img[loading="lazy"]'),function(img){
      if(img.closest('.sv-wa,.s-nav,header'))return;
      if(img.getBoundingClientRect().top<vh)return;
      if(img.complete&&img.naturalWidth)return;
      img.classList.add('sv-img');
      function done(){img.classList.add('is-loaded')}
      img.addEventListener('load',done,{once:true});
      img.addEventListener('error',done,{once:true});
      setTimeout(done,4000);
    });
  }

  /* 3. Scroll reveal for pages that do not have the home page's own. */
  function reveal(){
    if(reduce||!('IntersectionObserver' in window))return;
    if(document.querySelector('[data-sv]'))return;
    var main=document.querySelector('main')||document.body;
    var sel='.lp .sec > *,.lp .w:not(.hero) > *,.pd-body h2,.pd-body section,.sg-body h2,.sg-body p,.sg-body figure,.sg-body table,.sg-body details,.rte h2,.rte figure,.rte table,.rte details,.rte .sv-card';
    var vh=window.innerHeight,list=[];
    Array.prototype.forEach.call(main.querySelectorAll(sel),function(el){
      if(el.closest('.lpcar,.lptick,.sticky,.sv-wa'))return;
      if(el.getBoundingClientRect().top<vh*.92)return;
      el.classList.add('sv-r');list.push(el);
    });
    if(!list.length)return;
    var io=new IntersectionObserver(function(es){
      var n=0;
      es.forEach(function(e){if(e.isIntersecting){e.target.style.setProperty('--svd',Math.min(n++*80,320)+'ms');e.target.classList.add('in');io.unobserve(e.target)}});
    },{rootMargin:'0px 0px -8% 0px'});
    list.forEach(function(el){io.observe(el)});
    setTimeout(function(){list.forEach(function(el){el.classList.add('in')})},6000);
  }

  /* 4. Reading progress and header state. */
  function chrome(){
    var bar=document.createElement('div');bar.className='sv-progress';bar.setAttribute('aria-hidden','true');bar.innerHTML='<i></i>';
    document.body.appendChild(bar);
    var fill=bar.firstChild,ticking=false,root=document.documentElement;
    function paint(){
      ticking=false;
      var y=sy(),max=Math.max(1,sh());
      fill.style.transform='scaleX('+Math.min(1,y/max).toFixed(4)+')';
      root.classList.toggle('sv-scrolled',y>24);
      if(wa&&!wa.classList.contains('is-on')&&y>window.innerHeight*.45)showWa();
    }
    function q(){if(!ticking){ticking=true;requestAnimationFrame(paint)}}
    window.addEventListener('scroll',q,{passive:true});
    window.addEventListener('resize',q,{passive:true});
    paint();
  }

  /* 5. Floating WhatsApp, with a one-line nudge once per visit. */
  var wa=null;
  function whatsapp(){
    var p=location.pathname;
    if(/^\/pages\/(book-a-visit|contact)/.test(p)||/^\/(cart|checkout|account)/.test(p))return;
    var title=(document.querySelector('h1')||{}).textContent||'';
    title=title.replace(/\s+/g,' ').trim().slice(0,80);
    var msg='Hello SALVE, I am looking at '+(title?'"'+title+'"':'your site')+' and would like to ask about an appointment.';
    wa=document.createElement('a');
    wa.className='sv-wa';wa.href=WA+'?text='+encodeURIComponent(msg);wa.target='_blank';wa.rel='noopener';
    wa.setAttribute('aria-label','Ask SALVE on WhatsApp');
    wa.setAttribute('data-track','whatsapp_float');
    wa.innerHTML='<span class="sv-wa__tip" role="status"><b>Questions about fit or cloth?</b>A tailor replies on WhatsApp, usually within the hour.</span>'+
      '<span class="sv-wa__btn"><svg viewBox="0 0 32 32" fill="currentColor" aria-hidden="true"><path d="M16 3C8.8 3 3 8.7 3 15.8c0 2.5.7 4.9 2 6.9L3 29l6.5-2c1.9 1 4.1 1.6 6.5 1.6 7.2 0 13-5.7 13-12.8S23.2 3 16 3zm0 23.3c-2.1 0-4.1-.6-5.8-1.7l-.4-.2-3.9 1.2 1.2-3.7-.3-.4a10.3 10.3 0 0 1-1.7-5.7C5.1 9.9 10 5.2 16 5.2s10.9 4.7 10.9 10.6S22 26.3 16 26.3zm6-7.9c-.3-.2-1.9-.9-2.2-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-1 1.2-.2.2-.4.2-.7.1-.3-.2-1.4-.5-2.6-1.6-1-.9-1.6-1.9-1.8-2.2-.2-.3 0-.5.1-.7l.5-.6.3-.5c.1-.2 0-.4 0-.6l-1-2.4c-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.7s1.2 3.2 1.4 3.4c.2.2 2.4 3.6 5.8 5 .8.3 1.4.5 1.9.7.8.3 1.5.2 2.1.1.6-.1 1.9-.8 2.2-1.5.3-.7.3-1.4.2-1.5-.1-.1-.3-.2-.6-.3z"/></svg></span>';
    document.body.appendChild(wa);
    setTimeout(showWa,5000);
    wa.addEventListener('click',function(){
      try{if(window.gtag)gtag('event','whatsapp_click',{placement:'float'})}catch(e){}
      try{if(window.fbq)fbq('track','Contact')}catch(e){}
    });
  }
  function showWa(){
    if(!wa||wa.classList.contains('is-on'))return;
    wa.classList.add('is-on');
    var seen=false;try{seen=sessionStorage.getItem('sv-wa-tip')==='1'}catch(e){}
    if(seen)return;
    setTimeout(function(){
      wa.classList.add('tip');
      try{sessionStorage.setItem('sv-wa-tip','1')}catch(e){}
      setTimeout(function(){wa.classList.remove('tip')},7000);
    },9000);
  }

  ready(function(){
    whatsapp();
    chrome();
    ctaSweep();
    images();
    reveal();
    /* Carousels and product lists render late; sweep again. */
    setTimeout(ctaSweep,1500);
    window.addEventListener('load',ctaSweep);
  });
})();
